module.exports = __webpack_public_path__ + "img/bg_right_bottom.6ebd93b5.png";